import { render, staticRenderFns } from "./SignupTeacher.vue?vue&type=template&id=ac5ccf12"
import script from "../../services/teacher/signup-teacher.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/signup-teacher.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/teacher/signup-teacher.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports